/** Grantable team sections (mirror of server/src/services/teamSections.ts). */
export const TEAM_SECTIONS = [
  { key: 'post', label: 'Crear publicación' },
  { key: 'posts', label: 'Publicaciones' },
  { key: 'calendar', label: 'Calendario' },
  { key: 'analytics', label: 'Analítica' },
  { key: 'approvals', label: 'Aprobaciones' },
  { key: 'inspiration', label: 'Inspiración' },
  { key: 'bio', label: 'Link in bio' },
] as const;

export type TeamSectionKey = (typeof TEAM_SECTIONS)[number]['key'];
